import { useSelector } from 'react-redux';
import { RootState } from 'src/types/state.types';

export const useGetInspectorDataset = (datasetID: string) => {
  return useSelector((state: RootState) => {
    const userDataset = state.datasets[datasetID];

    const internalDataset = state.internalEntities.datasets?.find((d) => d._id === datasetID);

    const dataset = userDataset ?? internalDataset;

    let originalDataset; // only in case of dead letter datasets

    if (dataset && dataset?.originalDataset) {
      originalDataset = state.internalEntities.datasets?.find(
        (d) => d._id === dataset.originalDataset
      );
    }

    return { dataset, originalDataset };
  });
};
